export default __webpack_public_path__ + "static/media/airIcon.40cab282.svg";